/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  RequestCodeErrorResponse,
  RequestCodeRequest,
  RequestCodeSuccessResponse,
  ServerErrorResponse,
} from './api.schemas';

import { api } from '../util/http';

export const tfaRequest = (requestCodeRequest: RequestCodeRequest, signal?: AbortSignal) => {
  return api<RequestCodeSuccessResponse>({
    url: `/api/auth/tfa/request`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestCodeRequest,
    signal,
  });
};

export const getTfaRequestMutationOptions = <
  TError = RequestCodeErrorResponse | ServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tfaRequest>>,
    TError,
    { data: RequestCodeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tfaRequest>>,
  TError,
  { data: RequestCodeRequest },
  TContext
> => {
  const mutationKey = ['tfaRequest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tfaRequest>>,
    { data: RequestCodeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return tfaRequest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TfaRequestMutationResult = NonNullable<Awaited<ReturnType<typeof tfaRequest>>>;
export type TfaRequestMutationBody = RequestCodeRequest;
export type TfaRequestMutationError = RequestCodeErrorResponse | ServerErrorResponse;

export const useTfaRequest = <
  TError = RequestCodeErrorResponse | ServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tfaRequest>>,
      TError,
      { data: RequestCodeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tfaRequest>>,
  TError,
  { data: RequestCodeRequest },
  TContext
> => {
  const mutationOptions = getTfaRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
